"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSvgPanZoom = require("react-svg-pan-zoom");
var _svgData = require("./svgData");
var _kinaseInfo = require("./kinaseInfo");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function getStyleProp(kinase, styles, prop) {
  var _styles$kinase, _styles$kinaseInfo$ki, _kinaseInfo$kinase;
  return ((_styles$kinase = styles[kinase]) === null || _styles$kinase === void 0 ? void 0 : _styles$kinase[prop]) || ((_styles$kinaseInfo$ki = styles[(_kinaseInfo$kinase = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase === void 0 ? void 0 : _kinaseInfo$kinase.group]) === null || _styles$kinaseInfo$ki === void 0 ? void 0 : _styles$kinaseInfo$ki[prop]) || styles[prop];
}
function CoralMap(_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    _ref$staticMap = _ref.staticMap,
    staticMap = _ref$staticMap === void 0 ? false : _ref$staticMap,
    _ref$TooltipComponent = _ref.TooltipComponent,
    TooltipComponent = _ref$TooltipComponent === void 0 ? false : _ref$TooltipComponent;
  var Viewer = (0, _react.useRef)(null);
  var ref = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(200),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(200),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    resize = _useState6[0],
    setResize = _useState6[1];
  var _useState7 = (0, _react.useState)('none'),
    _useState8 = _slicedToArray(_useState7, 2),
    tool = _useState8[0],
    setTool = _useState8[1];
  var _useState9 = (0, _react.useState)(_reactSvgPanZoom.INITIAL_VALUE),
    _useState0 = _slicedToArray(_useState9, 2),
    value = _useState0[0],
    setValue = _useState0[1];
  var svgMemo = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("svg", {
      version: "1.1",
      className: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "150 0 700 650",
      style: {
        background: 'white',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 700
      }
    }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, "@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\n                \n                        text {\n                                font-family: \"Roboto\", sans-serif;\n                                font-weight: 700;\n                                font-style: normal;\n                        } ")), /*#__PURE__*/_react["default"].createElement("g", {
      className: "PLOT"
    }, Object.keys(_svgData.svgKinaseData).filter(function () {
      return !!styles.branchColor;
    }).map(function (kinase) {
      var _styles$kinase2, _styles$kinaseInfo$ki2, _kinaseInfo$kinase2;
      return /*#__PURE__*/_react["default"].createElement(KinaseBranch, {
        branchColor: styles.branchColor,
        kinase: kinase,
        TooltipComponent: TooltipComponent,
        tooltip: styles.tooltip || ((_styles$kinase2 = styles[kinase]) === null || _styles$kinase2 === void 0 ? void 0 : _styles$kinase2.tooltip) || ((_styles$kinaseInfo$ki2 = styles[(_kinaseInfo$kinase2 = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase2 === void 0 ? void 0 : _kinaseInfo$kinase2.group]) === null || _styles$kinaseInfo$ki2 === void 0 ? void 0 : _styles$kinaseInfo$ki2.tooltip)
      });
    }), Object.keys(_svgData.svgKinaseData).filter(function (kinase) {
      var _styles$kinaseInfo$ki3, _kinaseInfo$kinase3;
      return !!((_styles$kinaseInfo$ki3 = styles[(_kinaseInfo$kinase3 = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase3 === void 0 ? void 0 : _kinaseInfo$kinase3.group]) !== null && _styles$kinaseInfo$ki3 !== void 0 && _styles$kinaseInfo$ki3.branchColor);
    }).map(function (kinase) {
      var _styles$kinaseInfo$ki4, _kinaseInfo$kinase4, _styles$kinase3, _styles$kinaseInfo$ki5, _kinaseInfo$kinase5;
      return /*#__PURE__*/_react["default"].createElement(KinaseBranch, {
        branchColor: (_styles$kinaseInfo$ki4 = styles[(_kinaseInfo$kinase4 = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase4 === void 0 ? void 0 : _kinaseInfo$kinase4.group]) === null || _styles$kinaseInfo$ki4 === void 0 ? void 0 : _styles$kinaseInfo$ki4.branchColor,
        kinase: kinase,
        TooltipComponent: TooltipComponent,
        tooltip: styles.tooltip || ((_styles$kinase3 = styles[kinase]) === null || _styles$kinase3 === void 0 ? void 0 : _styles$kinase3.tooltip) || ((_styles$kinaseInfo$ki5 = styles[(_kinaseInfo$kinase5 = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase5 === void 0 ? void 0 : _kinaseInfo$kinase5.group]) === null || _styles$kinaseInfo$ki5 === void 0 ? void 0 : _styles$kinaseInfo$ki5.tooltip)
      });
    }), Object.keys(_svgData.svgKinaseData).filter(function (kinase) {
      var _styles$kinase4;
      return !!((_styles$kinase4 = styles[kinase]) !== null && _styles$kinase4 !== void 0 && _styles$kinase4.branchColor);
    }).map(function (kinase) {
      var _styles$kinase5, _styles$kinase6, _styles$kinaseInfo$ki6, _kinaseInfo$kinase6;
      return /*#__PURE__*/_react["default"].createElement(KinaseBranch, {
        branchColor: (_styles$kinase5 = styles[kinase]) === null || _styles$kinase5 === void 0 ? void 0 : _styles$kinase5.branchColor,
        kinase: kinase,
        TooltipComponent: TooltipComponent,
        tooltip: styles.tooltip || ((_styles$kinase6 = styles[kinase]) === null || _styles$kinase6 === void 0 ? void 0 : _styles$kinase6.tooltip) || ((_styles$kinaseInfo$ki6 = styles[(_kinaseInfo$kinase6 = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase6 === void 0 ? void 0 : _kinaseInfo$kinase6.group]) === null || _styles$kinaseInfo$ki6 === void 0 ? void 0 : _styles$kinaseInfo$ki6.tooltip)
      });
    }), Object.keys(_svgData.svgKinaseData).map(function (kinase) {
      return /*#__PURE__*/_react["default"].createElement(KinaseNode, {
        key: kinase,
        kinase: kinase,
        nodeColor: getStyleProp(kinase, styles, 'nodeColor'),
        nodeSize: getStyleProp(kinase, styles, 'nodeSize'),
        tooltip: getStyleProp(kinase, styles, 'tooltip'),
        TooltipComponent: TooltipComponent
      });
    }), Object.keys(_svgData.svgKinaseData).map(function (kinase) {
      var _styles$kinase7, _styles$kinaseInfo$ki7, _kinaseInfo$kinase7, _styles$kinase8, _styles$kinaseInfo$ki8, _kinaseInfo$kinase8, _styles$kinase9;
      return /*#__PURE__*/_react["default"].createElement("text", {
        key: kinase,
        textAnchor: "middle",
        fill: ((_styles$kinase7 = styles[kinase]) === null || _styles$kinase7 === void 0 ? void 0 : _styles$kinase7.textColor) || ((_styles$kinaseInfo$ki7 = styles[(_kinaseInfo$kinase7 = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase7 === void 0 ? void 0 : _kinaseInfo$kinase7.group]) === null || _styles$kinaseInfo$ki7 === void 0 ? void 0 : _styles$kinaseInfo$ki7.textColor) || styles.textColor || "rgba(0,0,0,0)",
        fontSize: ((_styles$kinase8 = styles[kinase]) === null || _styles$kinase8 === void 0 ? void 0 : _styles$kinase8.textSize) || ((_styles$kinaseInfo$ki8 = styles[(_kinaseInfo$kinase8 = _kinaseInfo.kinaseInfo[kinase]) === null || _kinaseInfo$kinase8 === void 0 ? void 0 : _kinaseInfo$kinase8.group]) === null || _styles$kinaseInfo$ki8 === void 0 ? void 0 : _styles$kinaseInfo$ki8.textSize) || styles.textSize || "2.25px",
        transform: _svgData.svgKinaseData[kinase].textTransform,
        style: {
          pointerEvents: 'none'
        }
      }, ((_styles$kinase9 = styles[kinase]) === null || _styles$kinase9 === void 0 ? void 0 : _styles$kinase9.name) || kinase);
    }), /*#__PURE__*/_react["default"].createElement("g", {
      className: "ATYPICAL_GROUPS"
    }, Object.keys(_svgData.svgAtypicalGroupLabelsData).map(function (group) {
      var _styles$atypicalLabel, _styles$label, _styles$group, _styles$atypicalLabel2, _styles$label2, _styles$group2, _styles$group3;
      return /*#__PURE__*/_react["default"].createElement("text", {
        key: group,
        fill: ((_styles$atypicalLabel = styles.atypicalLabel) === null || _styles$atypicalLabel === void 0 ? void 0 : _styles$atypicalLabel.textColor) || ((_styles$label = styles.label) === null || _styles$label === void 0 ? void 0 : _styles$label.textColor) || ((_styles$group = styles[group]) === null || _styles$group === void 0 || (_styles$group = _styles$group.label) === null || _styles$group === void 0 ? void 0 : _styles$group.textColor) || styles.textColor || "rgba(0,0,0,0)",
        fontSize: ((_styles$atypicalLabel2 = styles.atypicalLabel) === null || _styles$atypicalLabel2 === void 0 ? void 0 : _styles$atypicalLabel2.textSize) || ((_styles$label2 = styles.label) === null || _styles$label2 === void 0 ? void 0 : _styles$label2.textSize) || ((_styles$group2 = styles[group]) === null || _styles$group2 === void 0 || (_styles$group2 = _styles$group2.label) === null || _styles$group2 === void 0 ? void 0 : _styles$group2.textSize) || styles.textSize || "6px",
        transform: _svgData.svgAtypicalGroupLabelsData[group].textTransform,
        style: {
          pointerEvents: 'none'
        }
      }, ((_styles$group3 = styles[group]) === null || _styles$group3 === void 0 ? void 0 : _styles$group3.name) || group);
    })), /*#__PURE__*/_react["default"].createElement("g", {
      className: "GROUPS"
    }, Object.keys(_svgData.svgGroupLabelsData).map(function (group) {
      var _styles$group4, _styles$typicalLabel, _styles$label3, _styles$group5, _styles$typicalLabel2, _styles$label4, _styles$group6;
      return /*#__PURE__*/_react["default"].createElement("text", {
        fill: ((_styles$group4 = styles[group]) === null || _styles$group4 === void 0 || (_styles$group4 = _styles$group4.label) === null || _styles$group4 === void 0 ? void 0 : _styles$group4.textColor) || ((_styles$typicalLabel = styles.typicalLabel) === null || _styles$typicalLabel === void 0 ? void 0 : _styles$typicalLabel.textColor) || ((_styles$label3 = styles.label) === null || _styles$label3 === void 0 ? void 0 : _styles$label3.textColor) || styles.textColor || "rgba(0,0,0,0)",
        fontSize: ((_styles$group5 = styles[group]) === null || _styles$group5 === void 0 || (_styles$group5 = _styles$group5.label) === null || _styles$group5 === void 0 ? void 0 : _styles$group5.textSize) || ((_styles$typicalLabel2 = styles.typicalLabel) === null || _styles$typicalLabel2 === void 0 ? void 0 : _styles$typicalLabel2.textSize) || ((_styles$label4 = styles.label) === null || _styles$label4 === void 0 ? void 0 : _styles$label4.textSize) || styles.textSize || "13px",
        key: group,
        transform: _svgData.svgGroupLabelsData[group].textTransform,
        style: {
          pointerEvents: 'none'
        }
      }, ((_styles$group6 = styles[group]) === null || _styles$group6 === void 0 ? void 0 : _styles$group6.name) || group);
    }))));
  }, [styles]);
  (0, _react.useLayoutEffect)(function () {
    if (!ref.current) return;
    setWidth(ref.current.offsetWidth);
    setHeight(ref.current.offsetHeight);
    setResize(true);
    var resizeObserver = new ResizeObserver(function (event) {
      setHeight(event[0].contentBoxSize[0].blockSize);
      setWidth(event[0].contentBoxSize[0].inlineSize);
      setResize(true);
    });
    resizeObserver.observe(ref.current);
  }, [ref.current]);
  (0, _react.useEffect)(function () {
    if (!resize) return;
    setValue((0, _reactSvgPanZoom.fitToViewer)(value));
    setResize(false);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      background: 'red'
    },
    ref: ref
  }, !staticMap && /*#__PURE__*/_react["default"].createElement(_reactSvgPanZoom.ReactSVGPanZoom, {
    scaleFactorMax: 4.5,
    ref: Viewer,
    width: width,
    height: height,
    background: "green",
    tool: tool,
    onChangeTool: setTool,
    value: value,
    onChangeValue: setValue,
    detectAutoPan: false,
    toolbarProps: {
      position: staticMap ? 'none' : 'right'
    },
    miniatureProps: {
      position: 'none'
    },
    style: {
      pointerEvents: 'auto'
    }
  }, svgMemo), " ", staticMap && svgMemo);
}
function KinaseNode(_ref2) {
  var kinase = _ref2.kinase,
    nodeSize = _ref2.nodeSize,
    nodeColor = _ref2.nodeColor,
    tooltip = _ref2.tooltip,
    TooltipComponent = _ref2.TooltipComponent;
  return !!(TooltipComponent && tooltip) ? /*#__PURE__*/_react["default"].createElement(TooltipComponent, {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("ellipse", {
    fill: nodeColor || 'rgba(0,0,0,0)',
    cx: _svgData.svgKinaseData[kinase].nodePosition.cx,
    cy: _svgData.svgKinaseData[kinase].nodePosition.cy,
    rx: nodeSize || 6,
    ry: nodeSize || 5
  })) : /*#__PURE__*/_react["default"].createElement("ellipse", {
    fill: nodeColor || 'rgba(0,0,0,0)',
    cx: _svgData.svgKinaseData[kinase].nodePosition.cx,
    cy: _svgData.svgKinaseData[kinase].nodePosition.cy,
    rx: nodeSize || 6,
    ry: nodeSize || 5
  }, !!tooltip && /*#__PURE__*/_react["default"].createElement("title", null, tooltip));
}
function KinaseBranch(_ref3) {
  var kinase = _ref3.kinase,
    branchColor = _ref3.branchColor,
    tooltip = _ref3.tooltip,
    TooltipComponent = _ref3.TooltipComponent;
  return !!(TooltipComponent && tooltip) ? /*#__PURE__*/_react["default"].createElement(TooltipComponent, {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: branchColor,
    key: kinase,
    d: _svgData.svgKinaseData[kinase].branchPath
  })) : /*#__PURE__*/_react["default"].createElement("path", {
    fill: branchColor,
    key: kinase,
    d: _svgData.svgKinaseData[kinase].branchPath
  });
}
var _default = exports["default"] = CoralMap;